import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';

export const GET_CGI = '/v2/enterprise/communication/get';
export const SET_CGI = '/v2/enterprise/communication/set';

export enum SYNC_TYPE {
    ALL,
    CURRENT,
    NOT,
}

export enum TOGGLE {
    TOGGLE_TYPE = 'toggle_type',
    FILE_ID = 'file_id',
    TOGGLE_ON = 'toggle_on',
    TOGGLE_SCOPE = 'toggle_scope',
}

export enum TOAST_OCCASION {
    FIRST_SHOW = 'first-show',
    GENERATE_COPIES = 'generate-copies',
}

export enum SYNC_DESCRIPTION {
    NOT = '不同步',
    CURRENT = '同步本篇',
    ALL = '同步全部'
}

export const SYNC_CONFIG_MAP = {
    [ActionType.NOT_SYNC]: SYNC_TYPE.NOT,
    [ActionType.SYNC_CURRENT_FILE]: SYNC_TYPE.CURRENT,
    [ActionType.SYNC_ALL_FILE]: SYNC_TYPE.ALL,
};

export const SYNC_DESCRIPTION_MAP = {
    [ActionType.NOT_SYNC]: i18n.t(SYNC_DESCRIPTION.NOT),
    [ActionType.SYNC_CURRENT_FILE]: i18n.t(SYNC_DESCRIPTION.CURRENT),
    [ActionType.SYNC_ALL_FILE]: i18n.t(SYNC_DESCRIPTION.ALL),
};

export const IS_SYNC_TO_B_LIST = 'IS_SYNC_TO_B_LIST';
